import React from 'react';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import { DeliverySection } from '../../components/DeliverySection/DeliverySection';

export const DeliverySectionContainer = () => {
  const onDetailsLinkClick = (ev: React.MouseEvent<HTMLAnchorElement>) => {
    sendGALinkClickEvent(ev, {
      event: 'custom_event_v2',
      event_name: 'select_content',
      event_details: 'link click',
      content_type: 'delivery information',
      item_id: 'delivery and returns details',
    });
  };

  const onVisible = () => {
    sendGAEvent({
      event: 'custom_event_v2',
      event_name: 'view_content',
      event_details: undefined,
      content_type: 'delivery information',
      item_id: undefined,
    });
  };
  return <DeliverySection onDetailsLinkClick={onDetailsLinkClick} onVisible={onVisible} />;
};
